export default __webpack_public_path__ + "static/media/global-traits.66ddcd58.png";